var viewer_default = {
  "gallery_container": "rgO3-",
  "imageTitleContainer": "LnwJn",
  "clickableItem": "JnUIy",
  "prerender": "_0AkI3",
  "expandButton": "Z8OXQ",
  "itemContainer": "Z5PmJ",
  "expandIcon": "rXlSp",
  "itemOverlay": "USQe3",
  "imageTitle": "fmWVo",
  "pointer": "_7JN8N",
  "fadeIn": "QnyOL",
  "changing_background": "_6cMwy"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
